import React, { useState, useEffect, createContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Globals, Reset } from '@icecreamsocial/components';
import ThemeProvider from '../../providers/ThemeProvider';
import { Main } from '../../views/Main';
import { Snackbar } from '../../presentational';
import { FlavorLayout } from '../../container';
import { StoreProvider, usePostMessage } from '../../hooks';
import { useGTag } from '../../providers/GTagProvider/hooks/useGTag';
import { DisplayProvider } from '../../providers/DisplayProvider';
import { Localizer } from './Localizer';

const Initializer = () => {
	const [open, setOpen] = useState(false);
	const gtag = useGTag();
	// a little overkill, but we can simplify this later
	// @todo change this into a Map
	const [seed, setSeed] = useState(null);
	const [campaign, setCampaign] = useState(null);
	const [publicKey, setPublicKey] = useState(null);
	const [email, setEmail] = useState(null);
	const [name, setName] = useState(null);
	const [engagement, setEngagement] = useState(null);
	const [orderId, setOrderId] = useState(null);
	const [subtotal, setSubtotal] = useState(null);
	const [phoneNumber, setPhoneNumber] = useState(null);
	const [locale, setLocale] = useState(undefined);
	const [flavor, setFlavor] = useState(null);
	const [origin, setOrigin] = useState(null);
	const [productName, setProductName] = useState(null);
	const [productURL, setProductURL] = useState(null);
	const [promocode, setPromocode] = useState(null);
	const [inviteId, setInviteId] = useState(null);
	const [transactionId, setTransactionId] = useState(null);

	// theme overrides
	const [theme, setTheme] = useState({});

	const respondToParent = usePostMessage((e) => {
		try {
			if (e.origin !== e.data?.sender) return;

			const { data } = e;
			const handlers = {
				ics_open: handleOpen,
				ics_init: handleInit,
			};
			const handler = handlers[data.type] || function() {}; // noop on unknown command
			// this is a temporary check for how nested data is
			// i will get rid of this once the sdk is standardized in how
			// it dispatches messages
			handler(data.data?.data ? data.data : data);

			// console.groupEnd('Iframe');
		} catch (error) {
			console.error(error);
			throw error;
		}
	});

	// might want to track here
	const handleOpen = ({ data: dataLayer }) => {
		setOpen(true);
	};

	const handleInit = ({
		data: dataLayer,
		behavior,
		theme,
		type,
		variables,
		locale,
	}) => {
		setName(dataLayer.name || dataLayer.email);
		setCampaign(dataLayer.campaignId);
		setOrderId(dataLayer.orderId);
		setSubtotal(dataLayer.subtotal || dataLayer.revenue);
		setPhoneNumber(dataLayer.phoneNumber);
		setEmail(dataLayer.email);
		setTheme(theme);
		setLocale(locale);

		setSeed({
			...seed,
			Influencer: { orderId: dataLayer.orderId },
			publicKey: dataLayer.publicKey,
			engagement: dataLayer.engagement,
			inviteId: dataLayer.invite,
			subtotal: dataLayer.subtotal || dataLayer.revenue,
			transactionId: dataLayer.transactionId,
			flavor: behavior?.flavor,
			productName: variables?.productName,
			productURL: variables?.productURL,
			promocode: variables?.promocode,
		});
	};

	useEffect(() => {
		respondToParent(
			{
				type: 'ics_ready',
			},
			'*'
		);
	}, []);

	const displayContext = {
		open,
		setOpen: (isOpen) => setOpen(isOpen),
	};

	return (
		seed && (
			<StoreProvider seed={seed}>
				<ThemeProvider theme={theme}>
					<Localizer locale={locale}>
						<Globals />
						<Reset />
						<DisplayProvider value={displayContext}>
							<Snackbar>
								<FlavorLayout flavor={seed.flavor}>
									<Main
										campaignId={campaign}
										phoneNumber={phoneNumber}
										email={email}
										subtotal={subtotal}
										orderId={orderId}
										name={name}
									/>
								</FlavorLayout>
							</Snackbar>
						</DisplayProvider>
					</Localizer>
				</ThemeProvider>
			</StoreProvider>
		)
	);
};
export default observer(Initializer);
